// extracted by css-extract-rspack-plugin
export default {"downloadLink":"RosterOfEmployees__downloadLink--muA1I","container":"RosterOfEmployees__container--uUcz2","error":"RosterOfEmployees__error--dMR1E"};